<template>

  <v-simple-table>
    <thead>
      <tr>
        <th>Station Name</th>
        <th>Site Alias</th>
        <th>Latitude</th>
        <th>Longitude</th>
        <th>Soil Type</th>
        <th>Last Update</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in stations" :key="index" @click="$router.push('/station/' + item.SiteId)">
        <td>{{ item.Site_Name }}</td>
        <td>{{ item.site_alias }}</td>
        <td>{{ _.round(item.latitude,2) }}</td>
        <td>{{ _.round(item.longitude,2) }}</td>
        <td>{{ item.soil_texture }}</td>
        <td>{{item.dateTime.time.date}}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: 'TheStationTable',
  props: {
    stations: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
